import { render, staticRenderFns } from "./ModalHandbook.vue?vue&type=template&id=dde8c1dc&"
import script from "./ModalHandbook.vue?vue&type=script&lang=js&"
export * from "./ModalHandbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports